import {
  Module,
  VuexModule,
  getModule,
  Mutation,
} from "vuex-module-decorators";

import { Panel } from "../../data/models/Panel";

const name = "panel";

import store from "@/store";
import { getClientId } from "@/data/repository/ClientRepository";

if (store.state[name]) {
  store.unregisterModule(name);
}

@Module({ dynamic: true, namespaced: true, store, name: name })
export class PanelVuexModule extends VuexModule {
  panelCache = new Map<string, Panel>();
  panelsOfClientCache = new Map<string, Panel>();

  @Mutation
  cachePanel(panel: Panel) {
    if (!panel || !panel.serialNo) {
      return;
    }

    this.panelCache.set(panel.serialNo, panel);

    if (
      panel.currentAssignment?.clientId === getClientId() &&
      panel.panelStatus
    ) {
      this.panelsOfClientCache.set(panel.serialNo, panel);
    }
  }

  @Mutation
  chachePanelsOfClient(panelsOfClient: Array<Panel>) {
    this.panelsOfClientCache.clear();

    panelsOfClient.forEach((panel) => {
      if (!panel || !panel.serialNo) {
        return;
      }

      this.panelCache.set(panel.serialNo, panel);
      this.panelsOfClientCache.set(panel.serialNo, panel);
    });
  }

  @Mutation
  clear() {
    this.panelCache.clear();
    this.panelsOfClientCache.clear();
  }

  get cachedPanel() {
    const cache = this.panelCache;

    return function(serialNumber: string) {
      return cache.get(serialNumber);
    };
  }
}

export const PanelModule = getModule(PanelVuexModule);
